import React from "react";

const NotFoundPage = () => (
  <section class="container">
    <h1>404 - Page Not Found</h1>
    <p>Sorry, the page you are looking for does not exist.</p>
  </section>
);

export default NotFoundPage;
